import React, {useState} from 'react';
import TeacherTestAssignmentsDashboardWidget from "./TeacherTestAssignmentsDashboardWidget";

const TeacherAssignedWorkWidgetUSA = () => {
    const [isLoading, setLoading] = useState(false);

    return (
        <>
            <div className={'ch-dashboard-usa-assigned-work'}>
                <h2>See your student's progress</h2>
                <div>
                    <TeacherTestAssignmentsDashboardWidget />
                </div>
            </div>
        </>
    )
}

export default TeacherAssignedWorkWidgetUSA;